import download from 'downloadjs'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { getRangeFromDateFilter } from 'utils/dateUtils'
import { combineEpicsIsolated } from 'utils/epicRegistry'
import { wrapCSVTextToBlob, xhrExtractFileName } from 'utils/helpers'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import {
  fetchActivitiesCSVError,
  fetchActivitiesCSVSuccess,
  fetchActivitiesError,
  fetchActivitiesSuccess,
  fetchAllActivitiesFiltersError,
  fetchAllActivitiesFiltersSuccess,
} from './actions'
import {
  ACTIVITIES_CSV_PER_PAGE,
  ACTIVITIES_PER_PAGE,
  CREATED_BY_FILTER_CHANGE,
  DATE_FILTER_CHANGE,
  EVENTS_FILTER_CHANGE,
  FETCH_ACTIVITIES_ASYNC,
  FETCH_ACTIVITIES_CSV_ASYNC,
  FETCH_ALL_FILTERS_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SORT_PROPERTY_CHANGE,
  TARGETS_FILTER_CHANGE,
} from './constants'

const fetchActivitiesEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_ACTIVITIES_ASYNC.INITIATE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      EVENTS_FILTER_CHANGE,
      CREATED_BY_FILTER_CHANGE,
      TARGETS_FILTER_CHANGE,
      DATE_FILTER_CHANGE,
      SEARCH_CHANGE,
      PAGINATE_CHANGE,
      SORT_PROPERTY_CHANGE
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.activities.self)
      return true
    }),
    mergeMap(() =>
      api.accounts
        .getActivities(
          state$.value.partnerOptions.selectedCompany?.value,
          false,
          state$.value.activities.self.sortProperty,
          getRangeFromDateFilter(state$.value.activities.self.dateFilter),
          state$.value.activities.self.selectedEventType,
          state$.value.activities.self.selectedTargets,
          state$.value.activities.self.createdBy,
          state$.value.activities.self.page,
          state$.value.activities.self.search,
          ACTIVITIES_PER_PAGE
        )
        .pipe(
          map(({ response }) => fetchActivitiesSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchActivitiesError, error))),
          takeUntil(action$.pipe(ofType(FETCH_ACTIVITIES_ASYNC.CANCEL)))
        )
    )
  )

const fetchActivitiesCSVEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_ACTIVITIES_CSV_ASYNC.INITIATE),
    mergeMap(() =>
      api.accounts
        .getActivities(
          state$.value.partnerOptions.selectedCompany?.value,
          true,
          state$.value.activities.self.sortProperty,
          getRangeFromDateFilter(state$.value.activities.self.dateFilter),
          state$.value.activities.self.selectedEventType,
          state$.value.activities.self.selectedTargets,
          state$.value.activities.self.createdBy,
          state$.value.activities.self.page,
          state$.value.activities.self.search,
          ACTIVITIES_CSV_PER_PAGE
        )
        .pipe(
          map((response) => {
            download(
              wrapCSVTextToBlob(response.response),
              xhrExtractFileName(response.xhr),
              response.responseType
            )
            return fetchActivitiesCSVSuccess(response)
          }),
          catchError((error) => of(epicsErrorHandler(fetchActivitiesCSVError, error))),
          takeUntil(action$.pipe(ofType(FETCH_ACTIVITIES_CSV_ASYNC.CANCEL)))
        )
    )
  )

const fetchAllFiltersEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, FETCH_ALL_FILTERS_ASYNC.INITIATE),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.activities.self)
      return true
    }),
    mergeMap(() =>
      api.accounts.getActivitiesFilters(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map(({ response }) => fetchAllActivitiesFiltersSuccess(response)),
        catchError((error) => of(epicsErrorHandler(fetchAllActivitiesFiltersError, error)))
      )
    )
  )

export default combineEpicsIsolated(
  fetchActivitiesEpic,
  fetchActivitiesCSVEpic,
  fetchAllFiltersEpic
)
